import { Button, Dialog } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

const CancelConfirmationDialog = ({ isOpen, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      hasCloseButton
      onClose={onCancel}
      data-testid="upload-admin-document-modal"
      extraClasses="md:w-1/2 md:max-w-1/2"
    >
      <Dialog.Panel>
        <Dialog.Title>{t('enrollments.exitConfirmationModalTitle')}</Dialog.Title>
        <Dialog.Description>{t('enrollments.exitConfirmationModalContent')}</Dialog.Description>
      </Dialog.Panel>
      <Dialog.Actions>
        <Button label={t('enrollments.exitConfirmationModalGoBack')} extraClasses="w-full" onClick={onCancel} />
        <Button
          label={t('enrollments.exitConfirmationModalLeavePage')}
          extraClasses="w-full color-white bg-red-900 hover:bg-red-950"
          onClick={onConfirm}
          primary
        />
      </Dialog.Actions>
    </Dialog>
  );
};

export default CancelConfirmationDialog;
